module.exports = function () {
  if (window.navigator.getGamepads === undefined) {
    window.navigator.webkitGetGamepads;
  }
  var c =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    null;
  var d =
    window.cancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    null;
  this._connected = false;
  this.active = false;
  this._gamepad = null;
  this._events = {
    gamepad: {},
    axes: {},
  };
  this._keyMapping = {
    gamepad: {
      button_1: 0,
      button_2: 1,
      button_3: 2,
      button_4: 3,
      shoulder_top_left: 4,
      shoulder_top_right: 5,
      shoulder_bottom_left: 6,
      shoulder_bottom_right: 7,
      select: 8,
      start: 9,
      stick_button_left: 10,
      stick_button_right: 11,
      d_pad_up: 12,
      d_pad_down: 13,
      d_pad_left: 14,
      d_pad_right: 15,
    },
    axes: {
      stick_axis_left: [0, 2],
      stick_axis_right: [2, 4],
    },
  };
  this._threshold = 0.3;
  this._listeners = [];
  var f = this;
  this._handleGamepadConnected = function (g) {
    if (!f._connected) {
      f._connected = true;
      f.active = true;
      f._gamepad = g.gamepad;
      f._events.gamepad = {};
      f._events.axes = {};
      f._handleGamepadEventListener(g.gamepad);
      f._handleGamepadAxisEventListener(g.gamepad);
      f._requestAnimation = c(f._loop.bind(f));
    }
  };
  this._handleGamepadDisconnected = function () {
    d(f._requestAnimation);
    f._requestAnimation = null;
    f._connected = false;
    f._events.gamepad = null;
    f._events.axes = null;
    f._gamepad = null;
    f.active = false;
  };
  this._handleGamepadEventListener = function (g) {
    var h = f;
    if (g && g.connected) {
      g.buttons.forEach(function (j, k) {
        var l = (function (m, n) {
          var o = [];
          Object.keys(n).forEach(function (p) {
            if (n[p] === m || (Array.isArray(n[p]) && n[p].indexOf(m) !== -1)) {
              o.push(p);
            }
          });
          return o;
        })(k, h._keyMapping.gamepad);
        if (l) {
          l.forEach(function (m) {
            if (j.pressed) {
              if (!h._events.gamepad[m]) {
                h._events.gamepad[m] = {
                  pressed: true,
                  hold: false,
                  released: false,
                };
              }
              h._events.gamepad[m].value = j.value;
            } else if (!j.pressed && h._events.gamepad[m]) {
              h._events.gamepad[m].released = true;
              h._events.gamepad[m].hold = false;
            }
          });
        }
      });
    }
  };
  this._handleGamepadAxisEventListener = function (g) {
    var h = f;
    if (g && g.connected) {
      Object.keys(f._keyMapping.axes).forEach(function (j) {
        var k = Array.prototype.slice.apply(g.axes, h._keyMapping.axes[j]);
        if (Math.abs(k[0]) > h._threshold || Math.abs(k[1]) > h._threshold) {
          h._events.axes[j] = {
            pressed: !h._events.axes[j],
            hold: !!h._events.axes[j],
            released: false,
            value: k,
          };
        } else {
          h._events.axes[j] &&= {
            pressed: false,
            hold: false,
            released: true,
            value: k,
          };
        }
      });
    }
  };
  this._handleEvent = function (g, h) {
    f.active = true;
    if (h[g].pressed) {
      f.trigger("press", g, h[g].value);
      h[g].pressed = false;
      h[g].hold = true;
    } else if (h[g].hold) {
      f.trigger("hold", g, h[g].value);
    } else if (h[g].released) {
      f.trigger("release", g, h[g].value);
      delete h[g];
    }
  };
  this._loop = function () {
    var g = navigator.getGamepads
      ? navigator.getGamepads()
      : navigator.webkitGetGamepads
        ? navigator.webkitGetGamepads
        : [];
    if (!g) {
      return f._handleGamepadDisconnected();
    }
    f._gamepad = g[0];
    if (g[0] && g[0].connected) {
      f._handleGamepadEventListener(g[0]);
      f._handleGamepadAxisEventListener(g[0]);
    }
    if (f._events.gamepad) {
      Object.keys(f._events.gamepad).forEach(function (h) {
        f._handleEvent(h, f._events.gamepad);
      });
    }
    if (f._events.axes) {
      Object.keys(f._events.axes).forEach(function (h) {
        f._handleEvent(h, f._events.axes);
      });
    }
    f._requestAnimation &&= c(f._loop.bind(f));
  };
  this.on = function (g, h, j, k) {
    if (typeof g == "string" && g.match(/\s+/)) {
      g = g.split(/\s+/g);
    }
    if (typeof h == "string" && h.match(/\s+/)) {
      h = h.split(/\s+/g);
    }
    if (Array.isArray(g)) {
      g.forEach(function (l) {
        f.on(l, h, j, k);
      });
    } else if (Array.isArray(h)) {
      h.forEach(function (l) {
        f.on(g, l, j, k);
      });
    } else {
      f._listeners.push({
        type: g,
        button: h,
        callback: j,
        options: k,
        rumble: this.rumble,
      });
    }
  };
  this.off = function (g, h) {
    if (typeof g == "string" && g.match(/\s+/)) {
      g = g.split(/\s+/g);
    }
    if (typeof h == "string" && h.match(/\s+/)) {
      h = h.split(/\s+/g);
    }
    if (Array.isArray(g)) {
      g.forEach(function (j) {
        f.off(j, h);
      });
    } else if (Array.isArray(h)) {
      h.forEach(function (j) {
        f.off(g, j);
      });
    } else {
      f._listeners = f._listeners.filter(function (j) {
        return j.type !== g && j.button !== h;
      });
    }
  };
  this.trigger = function (g, h, j) {
    if (f._listeners) {
      f._listeners.forEach(function (k) {
        if (k.type === g && k.button === h) {
          k.callback({
            type: k.type,
            button: k.button,
            value: j,
            event: k,
            timestamp: Date.now(),
          });
        }
      });
    }
  };
  this.rumble = function (g, h) {
    if (
      f._gamepad &&
      f._gamepad.vibrationActuator &&
      f._gamepad.vibrationActuator.type == "dual-rumble" &&
      f._gamepad.vibrationActuator.playEffect
    ) {
      f._gamepad.vibrationActuator.playEffect("dual-rumble", {
        startDelay: 0,
        duration: g || 200,
        weakMagnitude: (h || 0.5) * 0.5,
        strongMagnitude: h || 0.5,
      });
    }
  };
  window.addEventListener(
    "MozGamepadConnected",
    this._handleGamepadConnected,
    false,
  );
  window.addEventListener(
    "MozGamepadDisconnected",
    this._handleGamepadDisconnected,
    false,
  );
  window.addEventListener(
    "gamepadconnected",
    this._handleGamepadConnected,
    false,
  );
  window.addEventListener(
    "gamepaddisconnected",
    this._handleGamepadDisconnected,
    false,
  );
};
